import React from 'react';
import cn from 'classnames';
import { Link } from 'react-router';
import A11y from 'chameleon/ui-stack/utilities/a11y';
import ButtonWithIcon from 'chameleon/ui-stack/ui/buttons/button-with-icon';
import styles from './styles.css';

const Pagination = ({
  className,
  currentPage,
  total,
  nextPage,
  prevPage,
  lastPage,
  firstPage,
  onButtonClick = () => {},
  afterNextPage,
  router,
}) => {
  const hasDots = afterNextPage && currentPage + 3 < total;
  const showFirstPage = currentPage > 2;
  return (
    <div className={cn('flex items-center', className)}>
      <ButtonWithIcon
        isIcon
        isOutline
        isLink
        icon="navigate_back"
        onClick={() => {
          prevPage && router.push(prevPage);
          onButtonClick();
        }}
        accessibility={{
          'aria-label': 'Previous page',
          'aria-disabled': !prevPage,
        }}
        tabIndex={prevPage ? 0 : undefined}
        disabled={!prevPage}
      />
      {showFirstPage && (
        <A11y>
          <Link
            onlyActiveOnIndex={false}
            onClick={onButtonClick}
            to={firstPage}
            aria-label="Page number 1"
            tabIndex="0"
            className={`${styles.page}`}
          >
            1
          </Link>
        </A11y>
      )}
      {showFirstPage && (
        <div data-test-id="dots" className={`${styles.page}`}>
          ...
        </div>
      )}
      {prevPage && (
        <A11y>
          <Link
            onlyActiveOnIndex={false}
            onClick={onButtonClick}
            to={prevPage}
            aria-label={`Page number ${currentPage - 1}`}
            tabIndex="0"
            className={`${styles.page}`}
          >
            {currentPage - 1}
          </Link>
        </A11y>
      )}

      <div
        data-test-id="current-page"
        className={`${styles.page} ${styles['is-active']}`}
        aria-current
      >
        {currentPage}
      </div>
      {nextPage && (
        <A11y>
          <Link
            onlyActiveOnIndex={false}
            onClick={onButtonClick}
            to={nextPage}
            aria-label={`Page number ${currentPage + 1}`}
            tabIndex="0"
            className={`${styles.page}`}
          >
            {currentPage + 1}
          </Link>
        </A11y>
      )}
      {afterNextPage && (
        <A11y>
          <Link
            onlyActiveOnIndex={false}
            onClick={onButtonClick}
            to={afterNextPage}
            aria-label={`Page number ${currentPage + 2}`}
            tabIndex="0"
            className={`${styles.page}`}
          >
            {currentPage + 2}
          </Link>
        </A11y>
      )}
      {hasDots && (
        <div data-test-id="dots" className={`${styles.page}`}>
          ...
        </div>
      )}
      {lastPage && (
        <A11y>
          <Link
            onlyActiveOnIndex={false}
            onClick={onButtonClick}
            to={lastPage}
            aria-label={`Page number ${total} (last page)`}
            tabIndex="0"
            className={`${styles.page}`}
            data-test-id="last-page"
          >
            {total}
          </Link>
        </A11y>
      )}
      <ButtonWithIcon
        isIcon
        isOutline
        isLink
        icon="navigate_next"
        onClick={() => {
          nextPage && router.push(nextPage);
          onButtonClick();
        }}
        accessibility={{
          'aria-label': 'Next page',
          'aria-disabled': !nextPage,
        }}
        tabIndex={nextPage ? 0 : undefined}
        disabled={!nextPage}
      />
    </div>
  );
};

export default Pagination;
